import { render, staticRenderFns } from "./VBtnExpand.vue?vue&type=template&id=4d7d9610"
import script from "./VBtnExpand.vue?vue&type=script&lang=js"
export * from "./VBtnExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports